import { Dictionary } from '@ngrx/entity';
import { Security } from '../models/security';

export const findSecurityById = (securities: Dictionary<Security>, id: number) => securities[id] || null;
